import { BaseTooltip } from '@/modules';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import React from 'react';

interface FaultReasonsProps {
  reasons?: string[];
  limit?: number;
  showReasons?: boolean;
  counterOnly?: boolean;
  size?: 'sm' | 'md';
  className?: string;
}
//@TODO: Move to upper shared
export const FaultReasons = ({
  reasons = [],
  limit = 1,
  showReasons = true,
  counterOnly = false,
  size = 'md',
  className,
}: FaultReasonsProps) => {
  if (!(reasons?.length > 0 && showReasons)) return null;
  const hidden = reasons.slice(counterOnly ? 0 : limit);
  return (
    <div className="flex gap-1 items-center h-2 pb-0.25">
      {reasons && reasons.length > hidden.length && (
        <Badge
          data-testid={'fault_reason'}
          className={cn('bg-neutral-50 items-center capitalize', `${size === 'sm' ? 'text-[10px]' : ''} `, className)}
        >
          {reasons[0]}
        </Badge>
      )}
      {hidden && hidden.length > 0 && (
        <BaseTooltip
          content={hidden.map((el, index) => (
            <span key={el} className="capitalize" data-testid={'fault_reason'}>{`${el} ${
              index < hidden.length - 1 ? ', ' : ''
            }`}</span>
          ))}
        >
          <Badge
            className={cn(
              'bg-neutral-50 items-center capitalized flex ',
              `${size === 'sm' ? 'py-[0.0625rem] mt-0.5' : 'pt-1'}`
            )}
          >
            +{hidden.length}
          </Badge>
        </BaseTooltip>
      )}
    </div>
  );
};
